import { render, staticRenderFns } from "./MultiListRowDetail.vue?vue&type=template&id=ca2c876a"
import script from "./MultiListRowDetail.vue?vue&type=script&lang=js"
export * from "./MultiListRowDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports